import React, { ReactNode } from 'react';
import { Box, BoxProps } from '@design-system/pc';

/**
 * 전문가 목록·상세 콘텐츠 폭. 이 컴포넌트는 전문가 목록·상세에서만 쓰인다.
 * RD2026-29 에서 당시 시안(RD 카드 585 × 2열) 기준 1170 으로 줄였으나,
 * QAISSUE-10450 수정 시안(7684:14041 목록 / 7684:10193 상세)에서 본문 폭이 1400 으로 확정됐다.
 * (GNB·Footer 는 1170 유지 — 이 컴포넌트와 무관)
 */
const CONTENT_WIDTH = 1400;

interface ResponsiveBoxProps {
  children?: ReactNode;
}

const ResponsiveBox = ({
  children,
  ...props
}: ResponsiveBoxProps & Omit<BoxProps, 'as' | 'children'>) => {
  return (
    <Box {...props} width={CONTENT_WIDTH} maxWidth={CONTENT_WIDTH} mx="auto">
      {children}
    </Box>
  );
};

export default ResponsiveBox;
